import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

const Notice = observer(class Notice extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.closeDialog = this.closeDialog.bind(this);
    this.updateTimeZone = this.updateTimeZone.bind(this);
  }

  closeDialog(e) {
    e.preventDefault();
    this.props.store.SessionStore.closeDialog();
  }

  updateTimeZone() {
    const { SessionStore, SettingsStore } = this.props.store;

    SettingsStore.userSettings.timeZoneSid = SessionStore.filteredMachineTimezone[0].sid;

    SettingsStore.updateUserSettings(SessionStore.getProfile);
  }

  render() {
    const { SessionStore } = this.props.store;

    if(!SessionStore.loading) {
      return(
        <div className={`toaster toaster--warning toaster--sm notice`}>
          <div className="wrap">
            <p>
              {SessionStore.noticeContent.body.replace('%course%', SessionStore.courseData.title)}&nbsp;

              {
                SessionStore.noticeContent.linkText &&
                SessionStore.noticeContent.linkUrl &&
                SessionStore.noticeContent.linkUrl !== '#update-timezone' &&
                <Link
                  to={SessionStore.noticeContent.linkUrl}
                >
                  {SessionStore.noticeContent.linkText}
                </Link>
              }

              {
                SessionStore.noticeContent.linkText &&
                SessionStore.noticeContent.linkUrl &&
                SessionStore.noticeContent.linkUrl === '#update-timezone' &&
                <button
                  className="btn--link"
                  onClick={this.updateTimeZone}
                >
                  {SessionStore.noticeContent.linkText}
                </button>
              }
            </p>
          </div>
        </div>
      );
    }

    return null;
  }
})

export default Notice;



// WEBPACK FOOTER //
// ./src/app/components/Common/Notice.js